import type { Money } from '~/graphql/graphql';

export type Price = Pick<Money, 'amount' | 'currency'>;

export function hasOneCurrency(
  prices: Iterable<Price | null | undefined>
): boolean {
  const currencies = new Set<Price['currency']>();
  for (const price of prices) {
    if (price) {
      currencies.add(price.currency);
    }
  }
  return currencies.size <= 1;
}

export function lowestPrice(
  prices: ReadonlyArray<Price | null | undefined>
): Price | null {
  // Prices in different currencies cannot be compared without conversion, so none is lowest.
  if (!hasOneCurrency(prices)) {
    return null;
  }
  let lowest: Price | null = null;
  for (const price of prices) {
    if (price != null && (lowest == null || price.amount < lowest.amount)) {
      lowest = price;
    }
  }
  return lowest;
}
